<template>
    <div>
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <vue-pdf-embed :key="pdfKey" :source="localPdfSource" @rendered="handleDocumentRender" />
    </div>
</template>

<script>
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
    components: {
        VuePdfEmbed,
    },

    props: {
        pdfKey: {
            type: [String, Number],
            default: '',
            required: true,
        },
        docSrc: {
            type: [String, Blob],
            default: '',
            required: true,
        },
    },

    data: () => ({
        isLoading: false,
        localPdfSource: '',
    }),

    watch: {
        docSrc: {
            handler: function (newSrc) {
                this.$nextTick(() => {
                    if (newSrc !== '' && newSrc !== this.localPdfSource) {
                        this.isLoading = true;
                        this.localPdfSource = newSrc;
                    }
                });
            },
            immediate: true,
        },
    },

    methods: {
        handleDocumentRender() {
            this.isLoading = false;
        },
    },
};
</script>

<style>
.vue-pdf-embed canvas {
    width: 100% !important;
    height: 100% !important;
}
</style>
